import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

export function usePlatformSetting<T = string>(key: string) {
  return useQuery<T | null>({
    queryKey: ['platform-settings', key],
    queryFn: async () => {
      const { data, error } = await (supabase as any)
        .from('platform_settings')
        .select('value')
        .eq('key', key)
        .maybeSingle();
      if (error) throw error;
      return data?.value ?? null;
    },
  });
}

export function useUpdatePlatformSetting() {
  const queryClient = useQueryClient();
  

  return useMutation({
    mutationFn: async ({ key, value }: { key: string; value: unknown }) => {
      const { error } = await (supabase as any)
        .from('platform_settings')
        .upsert({ key, value: JSON.stringify(value) }, { onConflict: 'key' });
      if (error) throw error;
    },
    onSuccess: (_, { key }) => {
      queryClient.invalidateQueries({ queryKey: ['platform-settings', key] });
      toast.success('Configuração salva');
    },
    onError: (err: Error) => {
      toast.error(`Erro ao salvar: ${err.message}`);
    },
  });
}
